import { PainelPropsGrid } from './styles'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Popover } from 'antd'

import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faDownLeftAndUpRightToCenter,
  faFileExport,
  faFloppyDisk,
  faList,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Render } from '../../../../../Components/CustomUi/render'
import Carregando from '../../../../../Components/CustomUi/loading'
import { AbasDoGrid } from '../abas'
import { GridMalha, GridPolygon } from '../gerarMalha'
import * as turf from '@turf/turf'
import { AbaMapa, CorrecaoSobreposicao, PreviaReducaoTrilhas } from './abaMapa'
import { AbaPontos } from './abaPontos'
import { AbaOrdenacao } from './abaOrdenacao'

interface PropsConfig {
  disable: boolean
  setDisable: React.Dispatch<React.SetStateAction<boolean>>
  aoCarregarArquivo: (rawData: string, base64Data: string) => void
  validoFile: boolean
  setValidoFile: React.Dispatch<React.SetStateAction<boolean>>
  rotation: number
  setRotation: React.Dispatch<React.SetStateAction<number>>
  rotacaoInput: string
  setRotacaoInput: React.Dispatch<React.SetStateAction<string>>
  movendo: boolean
  setMovendo: React.Dispatch<React.SetStateAction<boolean>>
  novoPonto: boolean
  setNovoPonto: React.Dispatch<React.SetStateAction<boolean>>
  moverPonto: boolean
  setMoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  removerPonto: boolean
  setRemoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  selecionarPonto: boolean
  setSelecionarPonto: React.Dispatch<React.SetStateAction<boolean>>
  gridLevel: string
  setGridLevel: React.Dispatch<React.SetStateAction<string>>
  position: { x: 0; y: 0 }
  setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>
  tab_container_atual: string
  setTab_container_atual: React.Dispatch<React.SetStateAction<string>>
  arquivoSelecionado: string
  setArquivoSelecionado: React.Dispatch<React.SetStateAction<string>>
  setGrid: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginal: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginalRotacao: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setTamanhoGridOriginal: React.Dispatch<React.SetStateAction<number>>
  setMalhaPolygon: React.Dispatch<React.SetStateAction<GridPolygon[]>>
  setMalhaPolygonOriginal: React.Dispatch<React.SetStateAction<GridPolygon[]>>
  setClicou: React.Dispatch<React.SetStateAction<boolean>>
  setQuadrante: React.Dispatch<React.SetStateAction<number>>
  kmlComCruzamento: boolean
  editandoKml: boolean
  setEditandoKml: React.Dispatch<React.SetStateAction<boolean>>
  areaHectares: number
  polygon: turf.Feature
  abaAtual: number
  abasNome: any[]
  pontosSelecionados: any[]
  grid: GridMalha[]
  area: any[]
  areaTamanho: number
  quadrante: number
  nomeTalhao: string
  avancar: Function
  voltar: Function
  resetarGrid: Function
  salvarMalha: () => void
  baixarMalha: (tipo: string) => void
  salvarContorno: () => void
  openCorrigirKinks: boolean
  setOpenCorrigirKinks: React.Dispatch<React.SetStateAction<boolean>>
  correcaoSobreposicoes: CorrecaoSobreposicao
  temAlgoParaCorrigir: boolean
  aplicarCorrecaoSobreposicoes: () => void
  openReducaoTrilhas: boolean
  setOpenReducaoTrilhas: React.Dispatch<React.SetStateAction<boolean>>
  distanciaTrilhas: number
  setDistanciaTrilhas: React.Dispatch<React.SetStateAction<number>>
  previaReducaoTrilhas: PreviaReducaoTrilhas
  aplicarReducaoTrilhas: () => void
  openReducaoRetas: boolean
  setOpenReducaoRetas: React.Dispatch<React.SetStateAction<boolean>>
  toleranciaRetas: number
  setToleranciaRetas: React.Dispatch<React.SetStateAction<number>>
  previaReducaoRetas: PreviaReducaoTrilhas
  aplicarReducaoRetas: () => void
}

const Configuracoes = React.memo<PropsConfig>(({
  aoCarregarArquivo,
  validoFile,
  rotation,
  setRotation,
  rotacaoInput,
  setRotacaoInput,
  movendo,
  setMovendo,
  novoPonto,
  setNovoPonto,
  moverPonto,
  setMoverPonto,
  removerPonto,
  setRemoverPonto,
  selecionarPonto,
  setSelecionarPonto,
  gridLevel,
  setGridLevel,
  position,
  setPosition,
  tab_container_atual,
  setTab_container_atual,
  arquivoSelecionado,
  setArquivoSelecionado,
  setGrid,
  setGridOriginal,
  setGridOriginalRotacao,
  setTamanhoGridOriginal,
  setQuadrante,
  kmlComCruzamento,
  editandoKml,
  setEditandoKml,
  areaHectares,
  polygon,
  abaAtual,
  abasNome,
  pontosSelecionados,
  grid,
  area,
  areaTamanho,
  quadrante,
  avancar,
  voltar,
  nomeTalhao,
  resetarGrid,
  salvarMalha,
  baixarMalha,
  salvarContorno,
  openCorrigirKinks,
  setOpenCorrigirKinks,
  correcaoSobreposicoes,
  temAlgoParaCorrigir,
  aplicarCorrecaoSobreposicoes,
  openReducaoTrilhas,
  setOpenReducaoTrilhas,
  distanciaTrilhas,
  setDistanciaTrilhas,
  previaReducaoTrilhas,
  aplicarReducaoTrilhas,
  openReducaoRetas,
  setOpenReducaoRetas,
  toleranciaRetas,
  setToleranciaRetas,
  previaReducaoRetas,
  aplicarReducaoRetas,
}) => {
  const [show, setShow] = useState<boolean>(false)
  const [shrink, setShrink] = useState<boolean>(false)
  const [loading, setLoading] = useState<string>('')

  return (
    <PainelPropsGrid data-shrink={shrink}>
      <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
        <ButtonCustom
          onClick={() => setShrink(!shrink)}
          type={shrink ? 'primary' : 'tertiary'}
          icon={
            <FontAwesomeIcon
              icon={shrink ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter}
            />
          }
          style={{ marginLeft: -15, alignSelf: 'flex-end', right: 0 }}
        />
      </div>
      <Render condition={shrink === false}>
        <AbasDoGrid abaAtual={tab_container_atual} mostrar={shrink} />
        <Render condition={show === false}>
          <Render condition={tab_container_atual === 'Mapa'}>
            <AbaMapa
              aoCarregarArquivo={aoCarregarArquivo}
              validoFile={validoFile}
              rotation={rotation}
              setRotation={setRotation}
              rotacaoInput={rotacaoInput}
              setRotacaoInput={setRotacaoInput}
              gridLevel={gridLevel}
              setGridLevel={setGridLevel}
              position={position}
              setPosition={setPosition}
              movendo={movendo}
              setMovendo={setMovendo}
              loading={loading}
              setLoading={setLoading}
              editandoKml={editandoKml}
              setEditandoKml={setEditandoKml}
              setGrid={setGrid}
              setGridOriginal={setGridOriginal}
              setGridOriginalRotacao={setGridOriginalRotacao}
              setTamanhoGridOriginal={setTamanhoGridOriginal}
              setQuadrante={setQuadrante}
              areaHectares={areaHectares}
              polygon={polygon}
              grid={grid}
              area={area}
              kmlComCruzamento={kmlComCruzamento}
              salvarContorno={salvarContorno}
              openCorrigirKinks={openCorrigirKinks}
              setOpenCorrigirKinks={setOpenCorrigirKinks}
              correcaoSobreposicoes={correcaoSobreposicoes}
              temAlgoParaCorrigir={temAlgoParaCorrigir}
              aplicarCorrecaoSobreposicoes={aplicarCorrecaoSobreposicoes}
              openReducaoTrilhas={openReducaoTrilhas}
              setOpenReducaoTrilhas={setOpenReducaoTrilhas}
              distanciaTrilhas={distanciaTrilhas}
              setDistanciaTrilhas={setDistanciaTrilhas}
              previaReducaoTrilhas={previaReducaoTrilhas}
              aplicarReducaoTrilhas={aplicarReducaoTrilhas}
              openReducaoRetas={openReducaoRetas}
              setOpenReducaoRetas={setOpenReducaoRetas}
              toleranciaRetas={toleranciaRetas}
              setToleranciaRetas={setToleranciaRetas}
              previaReducaoRetas={previaReducaoRetas}
              aplicarReducaoRetas={aplicarReducaoRetas}
            />
          </Render>

          <Render condition={tab_container_atual === 'Pontos'}>
            <AbaPontos
              novoPonto={novoPonto}
              setNovoPonto={setNovoPonto}
              moverPonto={moverPonto}
              setMoverPonto={setMoverPonto}
              removerPonto={removerPonto}
              setRemoverPonto={setRemoverPonto}
              area={areaTamanho}
              grid={grid}
              quadrante={quadrante}
            />
          </Render>

          <Render condition={abaAtual === 2}>
            <AbaOrdenacao
              selecionarPonto={selecionarPonto}
              setSelecionarPonto={setSelecionarPonto}
              arquivoSelecionado={arquivoSelecionado}
              setArquivoSelecionado={setArquivoSelecionado}
              pontosSelecionados={pontosSelecionados}
              resetarGrid={resetarGrid}
            />
          </Render>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <ButtonCustom
              onClick={voltar}
              type='secondary'
              danger
              icon={<FontAwesomeIcon icon={faArrowAltCircleLeft} />}
              disabled={tab_container_atual === 'Mapa'}
            >
              Voltar
            </ButtonCustom>
            <Render condition={tab_container_atual === 'Mapa' || tab_container_atual === 'Pontos'}>
              <ButtonCustom
                onClick={avancar}
                type='secondary'
                icon={<FontAwesomeIcon icon={faArrowAltCircleRight} />}
                disabled={grid.length <= 0 || kmlComCruzamento}
              >
                Avançar
              </ButtonCustom>
            </Render>
            <Render condition={abaAtual === 2}>
              <ButtonCustom
                onClick={() => salvarMalha()}
                type='primary'
                icon={<FontAwesomeIcon icon={faFileExport} />}
                disabled={!arquivoSelecionado}
              >
                Baixar
              </ButtonCustom>
            </Render>
          </div>
        </Render>
      </Render>
      <Render condition={show}>
        <Carregando animation legenda='Carregando...' justifyContent='center' height={400} />
      </Render>
    </PainelPropsGrid>
  )
})

export default Configuracoes